module.exports = __webpack_public_path__ + "static/img/bg_topic.8ade45b3.png";